import React from 'react';

const ArrowIcon = () => (
  <svg height="20px" width="20px" viewBox="0 0 1000 1000" fill="currentColor">
    <path d="M664.832 104.832l-68.272 68.288 274.88 274.88-274.88 274.88 68.272 68.288 343.168-343.168-343.168-343.168zM16 496.288h927.072v-96.576h-927.072v96.576z" />
  </svg>
);

export default ArrowIcon;
